import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerBilanciModalComponent} from './worker-bilanci-modal';

export const WorkerBilanciModalModule: string = ng
    .module('worker-bilanci-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerBilanciModalComponent', WorkerBilanciModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-bilanci-modal/worker-bilanci-modal.module.ts